<template>
	<div>
		<el-row>
			<el-col :lg="7" :md="9" :sm="12" :span="6" :xl="6" :xs="24">
				<img src="images/meiya_b.png" style="width: 100%" />
			</el-col>
			<el-col :lg="16" :md="14" :sm="12" :span="18" :xl="18" :xs="24">
				<div style="margin-left: 16px">
					<h2>
						美亚1-6类团意险（B款）
						<!--                        <span style="color:red;">建筑行业</span>-->
					</h2>
					<div style="color: red">1-6类职业 | 最高可保100万 | 5-6类可保高空</div>
					<p>
						① 线上投保，支持月单
						<br />
						② 社保用药免赔100元后100%赔付
						<br />
						③ 3人起保，最高可保100万
						<br />
						④ 意外医疗保额为单次事故限额，无次数限制，多次事故之间无间隔期
						<br />
					</p>
					<el-button size="medium" type="warning" @click.native="handleInsure">立即投保</el-button>
					<br />
					<el-button
						:loading="isDownLoading"
						icon="el-icon-download"
						size="medium"
						style="margin-top: 25px"
						type="text"
						@click.native="handleDownLoad">
						下载美亚团意险职业类别表
					</el-button>
				</div>
			</el-col>
		</el-row>
		<el-tabs v-model="currentStep">
			<el-tab-pane label="保险详情" name="0">
				<el-card>
					<el-row>
						<el-col :span="12">
							保障期限：
							<el-select v-model="qixian" placeholder="请选择保障期限" @change="computePrice">
								<el-option
									v-for="item in qixians"
									:key="item.value"
									:label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-col>
					</el-row>
					<avue-crud ref="crud" :data="dataPlan" :option="optionPlan" :span-method="spanMethodPlan"></avue-crud>
				</el-card>

				<!--                <el-card>-->
				<!--                    <avue-crud ref="plan"-->
				<!--                               :span-method="spanMethodPlan"-->
				<!--                               :option="optionPlan"-->
				<!--                               :data="dataPlan">-->
				<!--                    </avue-crud>-->

				<!--                </el-card>-->

				<!--        <el-card header="赔付标准">-->
				<!--          <el-row justify="center" type="flex">-->
				<!--            <span style="font-weight:500; color:Red; margin-bottom: 20px">社保用药范围100%赔付，伤残等级对应赔付比例请查看附表</span>-->
				<!--          </el-row>-->
				<!--          <avue-crud ref="crud"-->
				<!--                     :data="dataBenefit"-->
				<!--                     :option="optionShortPeriodRate">-->
				<!--            <template slot="header">-->
				<!--            </template>-->
				<!--          </avue-crud>-->
				<!--        </el-card>-->

				<el-card header="短期费率表">
					<el-row justify="center" type="flex">
						<span class="red-bold" style="margin-bottom: 20px">
							上述方案保费均为1年期保费，对于短期业务，保费按照年保险费率的百分比计算。保险期间不满一个月的，
							按一个月计算；保险期间在一个月以上、不足二个月的，按二个月计算；保险期间在二个月以上、不足三个月的，
							按三个月计算，依此类推。
						</span>
					</el-row>
					<avue-crud ref="crud" :data="dataBenefit" :option="optionShortPeriodRate"></avue-crud>
				</el-card>
			</el-tab-pane>
			<el-tab-pane label="常见问题" name="1">
				<el-row>
					<el-col :span="20">
						<ul>
							<li v-for="qa in dataQA" :key="qa.question">
								<div>
									<span
										style="
											display: inline-block;
											width: 20px;
											text-align: center;
											background-color: MediumPurple;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										Q
									</span>
									<span style="font-weight: bold">{{ qa.question }}</span>
								</div>
								<p></p>
								<div>
									<span
										style="
											display: inline-block;
											width: 20px;
											background-color: MediumSeaGreen;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										A
									</span>
									<span style="white-space: pre-wrap" v-html="qa.answer"></span>
								</div>
								<el-divider></el-divider>
							</li>
						</ul>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="投保须知" name="2">
				<el-row>
					<el-col :span="20">
						<h3>保险条款及须知</h3>

						<p style="line-height: 28px">
							1、本保险为互联网专属产品，由美亚财产保险有限公司（以下简称“保险公司”）承保，面向全国（不含港澳台）进行销售，本保险支持在线投保、核保、保单查询和报案等服务，您可以通过“美亚保险客户服务”微信小程序线上办理退保、批改和理赔等业务。目前保险公司在上海、北京、广东省（含深圳市）、江苏省和浙江省设有分支机构。
							<span style="font-weight: bold">
								保险公司无分支机构的地区，可能无法向您提供及时的面对面线下服务，保险公司将通过电话及互联网通道在线为您提供保单服务。如有任何疑问，可拨打保险公司客户服务热线400-820-8858。
							</span>
							<br />
							2、所有的保险责任及条款均以与保险公司正式订立保险合同的规定为准。
							<br />
							3、被保险人身故保险金受益人为被保险人的继承人。
							<br />
							4、投保人须获得被保险人的同意，方可为其投保本保险。
							<br />
							5、本保险约定的团体成员资格须同时满足以下要求：
							<br />
							（1）属于投保人所申报的符合所有投保条件的其于中国大陆境内直接雇佣的属于本保险接受投保职业类别的在岗全职雇员，
							<span style="font-weight: bold">
								但不包括任何国家或国际组织认定的恐怖分子或恐怖组织成员，或非法从事毒品、核武器、生物或化学武器交易人员。
							</span>
							<br />
							本保险所称的
							“直接雇佣”是指投保人与其所申报的人员直接订立书面劳动合同或其他书面形式的用工合同，该人员直接为投保人工作，并由投保人直接给付工资或报酬的情形，包括投保人短期雇用的情形。约定的团体成员投保年龄限制：18-65周岁。
							<br />
							（2）属于中国大陆境内（不含香港、澳门、台湾）常住，且身体健康、能正常工作和正常生活的被保险人，中国大陆境内常住是指被保险人参保时的前一个自然年度内在中国大陆境内的居住时间累计达到或超过183天。如任何投保人员在保险合同订立后或在保险合同有效期内发现不符合上述要求的，则
							<span style="font-weight: bold">
								保险公司有权依据合同约定取消该人员的被保资格，并对于取消其被保资格前所发生的保险事故不承担任何保险责任。
							</span>
							<br />
							6、保险合同成立时投保人数不低于3人。
							<span style="font-weight: bold">如被保险人含职业类别五或职业类别六，则被保险人人数应不低于5人。</span>
							单张保单最高投保人数为1000人。
							<br />
							7、
							<span style="font-weight: bold">
								保险公司在意外身故及伤残保障项下对所有被保险人于任一次意外事故中累计所给付的赔偿金额以不超过保险单所载的每一意外事故总赔偿限额为限。如在任一意外事故中，前述总赔偿限额低于按每一被保险人的保险金额给付的总赔偿金额，则保险公司将根据前述总赔偿限额与按每一被保险人的保险金额计算的赔偿总额的比例赔偿每一被保险人。
							</span>
							<br />
							8、
							<span style="font-weight: bold">每一意外事故总赔偿限额说明</span>
							： 每一意外事故总赔偿限额为以下两者较高者：
							<br />
							(1) 保险合同生效时，保险单所载单个被保险人在意外身故及伤残保障项下所适用的最高保险金额的10倍；
							<br />
							(1) 人民币500万元。
							<br />
							9、本保险计划项下计划一至计划八的被保险人职业类别限制为1类至6类，计划九和计划十的被保险人职业类别限制为1类至4类。
							<span style="font-weight: bold">
								具体职业请以职业分类表为准。保险公司不接受职业分类表所列1类至6类职业以外的其他职业的人员投保保险计划的申请。
							</span>
							<br />
							10、投保人须按照任何约定团体成员的实际职业类别申请参保相应保险计划。如被保险人工作涉及多个职业类别，则应以职业类别最高的职业为准选择相应类别。
							<span style="font-weight: bold">
								如任何约定团体成员的实际职业类别为本保险拒保职业类别或高于所申请参保保险计划对应的职业类别，则该团体成员不属于本保险所承保的参保人员，保险公司有权取消该团体成员的申报并在保险合同项下对该团体成员不承担任何保险责任。
							</span>
							<br />
							11、如被保险人在保险有效期内发生职业变化，投保人或被保险人应于十个工作日内向保险公司申请保全变更。如被保险人变更后的职业或工种依照职业分类表其危险程度降低时，则保险公司自被保险人变更职业或工种之日起，按日比例退还变更前后保险费的差额；如被保险人变更后的职业或工种依照职业分类表其危险增加时，投保人应自被保险人变更职业或工种之日起，按日比例补缴变更前后保险费的差额；如被保险人变更后的职业或工种为职业分类表的拒保职业，则自被保险人变更职业或工种之日起，保险公司对该被保险人所承担的保险责任终止，并按约定向投保人退还该被保险人对应的未满期保险费。
							<span style="font-weight: bold">
								若被保险人的职业或工种发生变化，依照职业分类表其危险程度增加而未依前项约定向保险公司申请变更而发生保险事故的，保险公司有权取消该被保险人的申报并在保险合同项下对该团体成员不承担任何保险责任。
							</span>
							<br />
							12、每位团体成员于保险公司投保的团体意外伤害保险仅限一份，多投无效，不同计划重叠购买的无效。若任一团体成员于保险公司投保多份团体意外伤害保险或购买多份计划，则保险公司仅以首次成功投保的计划为准，并退还其它保险计划项下已收取的保险费。
							<br />
							13、同一职业类别的被保险人必须选择相同的保险计划
							<br />
							14、本保险承保合同约定职业类别为5类和6类的被保险人在从事高处作业的职业活动期间所发生的保险事故。本保险所称的高处作业以《高处作业分级》（中华人民共和国国家标准GB/T
							3608-2008）中规定的为准，如属于在距坠落高度基准面5米及以上有可能坠落的高处进行作业，前述被保险人应依法取得规定的特种作业证书。
							<span style="font-weight: bold">
								若前述被保险人从事高处作业时未系绑安全带，则保险公司不承担任何保险责任。
							</span>
							<br />
							15、被保险人在保险期间内进行任何特种作业操作前，应依法取得规定的特种作业证书。
							<span style="font-weight: bold">
								若被保险人未依法取得规定的特种作业证书而进行特种作业操作的，则对于其因该特种作业操作导致的任何保险事故，保险公司不承担任何保险责任。
							</span>
							特种作业证书以国家《特种作业人员安全技术培训考核管理规定》规定的为准。
							<br />
							16、
							<span style="font-weight: bold">
								对于职业类别为1类至4类的被保险人，本保险不承保其任何5米及以上的高处作业。
							</span>
							<br />
							17、意外医药补偿保额说明：
							<br />
							（1）若任何被保险人没有公费医疗、社会基本医疗保险、其他费用补偿型医疗保险或被保险人未从公费医疗、社会基本医疗保险、其他费用补偿型医疗保险取得医药费用补偿，则保险公司对该被保险人在意外医药补偿保障项下支付的赔偿金额最高以上表所载该保障项下该被保险人相应的保险金额为限。
							<br />
							（2）若任何被保险人拥有且已从公费医疗、社会基本医疗保险或其他费用补偿型医疗保险取得医药费用补偿，则保险公司对该保险人在意外医药补偿保障项下支付的赔偿金额最高以上表所载该保障项下该被保险人相应的保险金额的105%为限，但须扣除该被保险人任何已取得的医药费用补偿。
							<br />
							18、
							<span style="font-weight: bold">
								本保险仅承保于境内发生的意外事故。本合同所称的境内是指中国大陆地区，不包括台湾省、香港及澳门特别行政区。
							</span>
							<br />
							19、
							<span style="font-weight: bold">
								本保险所称的医院仅指境内经国家卫生部门评审确定的二级以上（含二级）公立医院，不包括任何精神病院、养老机构、康复医院、诊所、天然治疗所，以及主要作为护理、疗养、戒酒、戒毒或类似目的的医疗机构。
							</span>
							<br />
							20、
							<span style="font-weight: bold">
								本保险所称的医院不包括下列医院：北京市（平谷区、密云区、怀柔区）、天津市（滨海新区、静海区）、福建省南平市、安徽省宿州市、河北省（三河市、廊坊市、青龙县、兴隆县）的所有医院；福建省宁德市古田县医院；河北省承德市第六医院、邯郸市第一医院、馆陶县人民医院、元氏县中医院；河南省（开封市、信阳市、新密市、内黄县、通许县）所有医院，河南省新乡市中医院、新乡市第二人民医院、焦作市第五人民医院、许昌县人民医院、商水县人民医院、濮阳县第二人民医院、鹤壁煤业（集团）有限责任公司总医院；山东省（莱州市、栖霞市、威海市、金乡县、禹城）所有医院，山东滨州市中心医院、鱼台县人民医院、青岛市即墨区中医院、荣成市中医院、烟台市中医医院、聊城市中医医院；四川省宜宾市所有医院、雅安市雨城区人民医院、雅安市第二人民医院、富顺县中医医院、绵阳市人民医院、泸州市纳溪区人民医院、内江市第四人民医院、阿坝州林业中心医院、遂宁市大英县中医院；甘肃省民勤县人民医院、宁县人民医院；山西省运城市盐湖区人民医院；黑龙江鸡西市所有医院，黑龙江省中医医院、牡丹江市中医院、牡丹江市第二人民医院、哈尔滨市第一医院、五大连池市第一人民医院；吉林省四平市所有医院，吉林省中医医院、通化市人民医院、长春市中心医院；辽宁省铁岭市所有医院，辽宁省中医医院；海南省第三人民医院。
							</span>
							<br />
							21、本保险为团体保险，投保人不得以任何方式销售给第三方（第三方包括但不限于被保险人本人）。
							<br />
							22、
							<span style="font-weight: bold">
								若保险、公司在本保险项下提供任何保险保障、利益或支付任何保险赔偿金会导致保险公司违反联合国决议项下的任何制裁、禁止性或限制性规定，或者违反中华人民共和国或美国颁布的任何经济贸易制裁、法律法规时，则保险公司在本保险项下不提供前述保险保障、利益，亦不支付前述保险赔偿金。
							</span>
							<br />
							23、
							<span style="font-weight: bold">
								本保险不承保任何国家或国际组织认定的恐怖分子或恐怖组织成员，或非法从事毒品、核武器、生物或化学武器交易人员。
							</span>
							<br />
							24、被保险人的投保年龄以申请时被保险人的周岁年龄为准。
							<br />
							25、新增或减少被保险人的申报：保险合同有效期间，若有团体成员的新增或减少，投保人须将该新增及减少的成员资料申报至保险公司。对于新增团体成员，经保险公司确认同意承保后，该新增成员自投保人申报次日零时起获得被保资格。
							<br />
							26、保险凭证：保险公司将为保险合同项下各被保险人签发保险凭证，投保人应负责向各被保险人送达保险凭证。
							<br />
							27、
							<span style="font-weight: bold">
								投保人未能披露与本保险相关之重大事实（包括但不限于是否符合本投保申请上述所有投保前提条件，下同）可能导致保险公司不承担保险责任。重大事实系指可能影响保险公司风险评估或接受投保申请与否之事实。如果投保人不能确定某些事实是否属于应披露之重大事实，请予以披露。
							</span>
							<br />
							28、本保险
							<span style="font-weight: bold">仅提供电子版本的保险单</span>
							，根据预留的电子邮件地址发送电子版本的保险单，投保人可登录
							<a
								href="https://www-401.aiginsurance.com.cn/CIRC/accident_policy_enquiry.asp"
								style="color: DodgerBlue"
								target="_blank">
								美亚保险信息 自主查询系统
							</a>
							进行保单验真。
							<br />
							29、本保险适用条款：《美亚附加仅承保境内意外事故条款（2021年第二版）（互联网专属）》《美亚附加不承保特定医院条款（2021年第二版）》《美亚附加每一意外事故总赔偿限额条款（2021年第一版）（互联网专属）》《美亚附加经济制裁责任免除条款》《美亚附加特定职业类别人员高处作业条款（2021年第二版）（互联网专属）》《美亚附加特种作业限制条款（2021年第二版）（互联网专属）》《美亚团体意外伤害保险（2021年第一版）（互联网专属）》《美亚附加意外医药补偿团体医疗保险（2021年第五版）（互联网专属）》《美亚附加意外每日住院津贴团体收入保障保险（2021年第一版）》
							<br />
							30、
							<span style="font-weight: bold">重要提示：</span>
							<br />
							(1)请仔细阅读本保险所有投保前提条件，确认符合所列投保前提条件方可进行投保。
							<br />
							(2)为了保障您自身的权益，请在确认投保本保险前，仔细阅读理解保险合同（包括但不限于保险条款等）的各项规定，尤其是免除保险人责任的规定。如有疑问，请致电：4008208858询问，并听取保险公司客服人员的说明。请确保您对保险公司客服人员的说明完全理解，没有异议。如未询问，则视同已经对合同内容完全理解并无异议。
							<br />
							(3)本投保申请、保险条款、保险单、批单或批注（如有）及其它约定书均为保险合同的构成部分。
							<br />
							(4)为了维护您的利益，投保人/被保险人需详细并如实填写投保申请上所列资料。
							<br />
							(5)美亚财产保险有限公司综合偿付能力充足率达到监管要求，且风险综合评级提示操作、战略、声誉和流动风险较小，具体偿付能力指标和风险综合评级结果请查询公司官方网站
							<a href="http://www.aig.com.cn" style="color: DodgerBlue" target="_blank">美亚财产保险有限公司官网</a>
							<br />
							(6)保险合同项下应付保险费含适用的增值税。
							<br />
						</p>

						<el-divider></el-divider>
						<h3>重要提示</h3>
						<p style="line-height: 32px">
							1、投保人须获得被保险人的同意，方可为其投保本保险。
							<br />
							2、本保险为团体保险，投保人不得以任何方式销售给第三方(第三方包括但不限于被保险人本人)
							<br />
							3、保险公司将为保险合同项下各被保险人签发保险凭证，投保人应负责向各被保险人送达保险凭证。
							<br />
							4、任何已提出投保申请的人员或在保险期间内可能提出参保申请的人员，均须符合本保险约定的被保险人资格如任何投保人员在保险合同订立后或在保险合同有效期内发现不符合上述要求的，则保险公司有权依据合同约定取消该人员的被保资格，并对于取消其被保资格前所发生的保险事故不承担任何保险责任。
							<br />
							5、投保人须按照任何约定团体成员的实际职业类别电请参保相应保险计划。如被保险人工作涉及多个职业类别则应以职业类别最高的职业为准选择相应类别。如任何约定团体成员的实际职业类别为本保险拒保职业类别或高于所申请参保保险计划对应的职业类别，则该团体成员不属于本保险所承保的参保人员，保险公司有权取消该团体成员的申报并在保险合同项下对该团体成员不承担任何保险责任。
							<br />
							6、如被保险人在保险有效期内发生职业变化，投保人或被保险人应于十个工作日内向保险公司申请保全变更。如被保险人变更后的职业或工种依照职业分类表其危险程度降低时，则保险公司自被保险人变更职业或工种之日起按日比例退还变更前后保险费的差额:如被保险人变更后的职业或工种依照职业分类表其危险增加时，投保人应自被保险人变更职业或工种之日起，按日比例补缴变更前后保险费的差额;如被保险人变更后的职业或工种为职业分类表的拒保职业，则自被保险人变更职业或工种之日起，保险公司对该被保险人所承担的保险责任终止，并按约定向投保人退还该被保险人对应的未满期保险费。
							<br />
							若被保险人的职业或工种发生变化，依照职业分类表其危险程度增加而未依前项约定向保险公司申请变更而发生保险事故的，保险公司有权取消该被保险人的申报并在保险合同项下对该团体成员不承担任何保险责任。
							<br />
							7、被保险人的身故保险金受益人为被保险人的继承人。
							<br />
							8、本公司在意外身故及伤残保障项下对所有被保险人于任一次意外事故中累计所给付的赔偿金额以不超过保险单所载的每一意外事故总暗偿限额为限。如在任一意外事故中，前述总赔偿限额低干按每一被保险人的保险金额给付的总赔偿金额，则本公司将根据前述总赔偿限额与按每一被保险人的保险金额计算的赔偿总额的比例赔偿每一被保险人。
							<br />
							9、若任何被保险人没有公费医疗、社会基本医疗保险、其他费用补偿型医疗保险或被保险人未从公费医疗、社会基本医疗保险、其他费用补偿型医疗保险取得医药费用补偿，则本公司对该被保险人在意外医药补偿保障项下支付的赔偿金额最高以上表所载该保障项下该被保险人相应的保险金额为限。若任何被保险人拥有自己从公费医疗、社会基本医疗保险或其他费用补偿型医疗保险取得医药费用补偿，则本公司对该保险人在意外医药补偿保障项下支付的赔偿金额最高以上表所载该保障项下该被保险人相应保险金额的百分之一百零五(105%)为限，但须扣除该被保险人任何已取得的医药费用补偿。
							<br />
							10、本保险承保合同约定职业类别为5类和6类的被保险人在从事高处作业的职业活动期间所发生的保险事故。本保险所称的高处作业以《高处作业分级》(中华人民共和国国家标准GB/T3608-2008)中规定的为准，如属于在距队落高度基准面5米及以上有可能落的高处进行作业，前述被保险人应依法取得规定的特种作业证书。若前述被保险人从事高处作业时未系绑安全带，则本公司不承担任何保险责任。
							<br />
							11、被保险人在保险期间内进行任何特种作业操作前，应依法取得规定的特种作业证书。若被保险人未依法取得规定的特种作业证书而进行特种作业操作的，则对于其因该特种作业操作导致的任何保险事故，本公司不承担任何保险责任。特种作业证书以国家(特种作业人员安全技术培训考核管理规定》规定的为准。
							<br />
							12、对于职业类别为1类至4类的被保险人，本保险不承保其从事5米及以上的高处作业时发生的保险事故。
							<br />
							13、本保险仅承保于境内发生的意外事故。本合同所称的境内是指中国大陆地区，不包括台湾省、香港及澳门特别行政区。
							<br />
							14、本保险所称的医院仅指境内经国家卫生部门评审确定的二级以上(含二级)公立医院，不包括任何精神病院、养老机构、康复医院、诊所、天然治疗所，以及主要作为护理、疗养、戒酒、戒毒或类似目的的医疗机构。
							<br />
							15本保险所称的医院不包括下列医院:北京市(平谷区、密云区、怀柔区)、天津市(滨海新区、静海区)、福建省南平市、安徽省宿州市、河北省(三河市、廊坊市、青龙县、兴隆县)的所有医院;福建省宁德市古田县医院;河北省承德市第六医院、邯郸市第一医院、馆陶县人民医院、元氏县中医院;河南省(开封市、信阳市、新密市、内黄县、通许县)所有医院，河南省新乡市中医院、新乡市第二人民医院
							焦作市第五人民医院、许昌县人民医院、商水县人民医院、濮阳县第二人民医院、鹤壁煤业(集团)有限责任公司总医院;山东省(莱州市栖霹市、威海市、金乡县、禹城)所有医院，山东滨州市中心医院、鱼台县人民医院、青岛市即墨区中医院、荣成市中医院、烟台市中医医院、聊城市中医医院;四川省宜宾市所有医院、雅安市雨城区人民医院、雅安市第二人民医院、富顺县中医医院、绵阳市人民医院
							泸州市纳溪区人民医院、内江市第四人民医院、阿坝州林业中心医院、遂宁市大英县中医院;甘肃省民勤县人民医院、宁县人民医院;山西省运城市盐湖区人民医院;黑龙江鸡西市所有医院，黑龙江省中医医院、牡丹江市中医院
							牡丹江市第二人民医院
							哈尔滨市第一医院、五大连池市第一人民医院;吉林省四平市所有医院，吉林省中医医院、通化市人民医院、长春市中心医院;辽宁省铁岭市所有医院，辽宁省中医医院:海南省第三人民医院。
							<br />
							16、本保险不承保任何国家或国际组织认定的恐怖分子或恐怖组织成员，或非法从事毒品、核武器、生物或化学武器交易人员。
							<br />
							17、若本保险公司在本保险项下提供任何保险保障、利益或支付任何保险赔偿金会导致本保险公司违反联合国决议项下的任何制裁、禁止性或限制性规定，或者违反中华人民共和国或美国颁布的任何经济贸易制裁、法律法规时，则本保险公司在本保险项下不提供前述保险保障、利益，亦不支付前述保险赔偿金。
							<br />
							18、本保险单与投保申请、保险条款、批单或批注(如有)及其它约定书均为保险合同的构成部分。
							<br />
							19、为了保障您自身的权益，请在确认投保本保险前，任细阅读理解保险合同(包括但不限于保险条款等)的各项规定，尤其是免除保险人责任的规定。如有疑问，请致电:4008208858询问，并听取保险公司客服人员的说明。请确保您对保险公司客服人员的说明完全理解，没有异议。如未询问，则视同已经对合同内容完全理解并无异议。
							<br />
							20、为了保障您的利益，请在收到本保险单一周内拨打我公司服务热线4008208858核实保险单资料，包括保险单所列示的销售人员或销售中介机构信息。
							<br />
							21、保险合同项下应付保险费含适用的增值税。
							<br />
						</p>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="下载" name="3">
				<avue-crud ref="crud_content" :data="listDatas" :option="option">
					<template slot="menu" slot-scope="{row}">
						<el-button icon="el-icon-download" type="text" @click="onDownload(row)">下载</el-button>
					</template>
				</avue-crud>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import {optionPlanMyB, optionTKDQ} from '@/const/crud/insurance/productDetail'
import {currentYYYYmmdd} from '@/util/date'
import {handleDownCategoryFile, handleDownCustom} from '@/util/util'

export default {
	name: 'Product45Details',
	props: {
		productId: {
			type: String | Number,
			required: true,
		},
	},
	data: function () {
		return {
			currentStep: '0',
			qixian: 12,
			qixians: [
				{
					value: 12,
					label: '12个月',
				},
				{
					value: 11,
					label: '11个月',
				},
				{
					value: 10,
					label: '10个月',
				},
				{
					value: 9,
					label: '9个月',
				},
				{
					value: 8,
					label: '8个月',
				},
				{
					value: 7,
					label: '7个月',
				},
				{
					value: 6,
					label: '6个月',
				},
				{
					value: 5,
					label: '5个月',
				},
				{
					value: 4,
					label: '4个月',
				},
				{
					value: 3,
					label: '3个月',
				},
				{
					value: 2,
					label: '2个月',
				},
				{
					value: 1,
					label: '1个月',
				},
			],
			optionShortPeriodRate: optionTKDQ,
			dataBenefit: [
				{
					levelItem: '百分比（%）',
					level12: '100%',
					level11: '95%',
					level10: '90%',
					level9: '85%',
					level8: '80%',
					level7: '75%',
					level6: '70%',
					level5: '60%',
					level4: '50%',
					level3: '40%',
					level2: '30%',
					level1: '20%',
				},
			],
			optionPlan: optionPlanMyB,
			dataPlan: [
				{
					insuredItem: '意外身故及伤残保障',
					plan1: '100000',
					plan2: '200000',
					plan3: '300000',
					plan4: '400000',
					plan5: '500000',
					plan6: '600000',
					plan7: '700000',
					plan8: '800000',
					plan9: '900000',
					plan10: '1000000',
				},
				{
					insuredItem:
						'意外医药补偿（每次意外事故限额)' +
						'（中国大陆境内医药费用仅限当地社保规定个人自负部分）' +
						'（含救护车费用年度累计限额RMB1,000）',
					plan1: '10000',
					plan2: '20000',
					plan3: '30000',
					plan4: '40000',
					plan5: '50000',
					plan6: '60000',
					plan7: '70000',
					plan8: '80000',
					plan9: '90000',
					plan10: '100000',
				},
				{
					insuredItem: '每次事故免赔额',
					plan1: '100',
					plan2: '100',
					plan3: '100',
					plan4: '100',
					plan5: '100',
					plan6: '100',
					plan7: '100',
					plan8: '100',
					plan9: '100',
					plan10: '100',
				},
				{
					insuredItem: '每次事故赔付比例',
					plan1: '100%',
					plan2: '100%',
					plan3: '100%',
					plan4: '100%',
					plan5: '100%',
					plan6: '100%',
					plan7: '100%',
					plan8: '100%',
					plan9: '100%',
					plan10: '100%',
				},
				{
					insuredItem: '意外每日住院津贴（每一保险年度总赔偿日数以180天为限）',
					plan1: '100/天',
					plan2: '100/天',
					plan3: '100/天',
					plan4: '100/天',
					plan5: '100/天',
					plan6: '100/天',
					plan7: '100/天',
					plan8: '100/天',
					plan9: '100/天',
					plan10: '100/天',
				},
				{
					insuredItem: '每次住院免责天数',
					plan1: '3天',
					plan2: '3天',
					plan3: '3天',
					plan4: '3天',
					plan5: '3天',
					plan6: '3天',
					plan7: '3天',
					plan8: '3天',
					plan9: '3天',
					plan10: '3天',
				},
				{
					insuredItem: '年保费',
				},
			],
			priceYear: [
				{
					insuredItem: '职业类别一',
					plan1: 77,
					plan2: 146,
					plan3: 215,
					plan4: 284,
					plan5: 353,
					plan6: 422,
					plan7: 491,
					plan8: 560,
					plan9: 629,
					plan10: 698,
				},
				{
					insuredItem: '职业类别二',
					plan1: 88,
					plan2: 164,
					plan3: 241,
					plan4: 318,
					plan5: 395,
					plan6: 472,
					plan7: 549,
					plan8: 626,
					plan9: 703,
					plan10: 780,
				},
				{
					insuredItem: '职业类别三',
					plan1: 125,
					plan2: 230,
					plan3: 335,
					plan4: 442,
					plan5: 550,
					plan6: 658,
					plan7: 766,
					plan8: 874,
					plan9: 982,
					plan10: 1090,
				},
				{
					insuredItem: '职业类别四',
					plan1: 160,
					plan2: 300,
					plan3: 440,
					plan4: 580,
					plan5: 720,
					plan6: 860,
					plan7: 1000,
					plan8: 1140,
					plan9: 1280,
					plan10: 1420,
				},
				{
					insuredItem: '职业类别五',
					plan1: 300,
					plan2: 570,
					plan3: 840,
					plan4: 1110,
					plan5: 1380,
					plan6: 1650,
					plan7: 1920,
					plan8: 2190,
					plan9: -1,
					plan10: -1,
				},
				{
					insuredItem: '职业类别六',
					plan1: 430,
					plan2: 810,
					plan3: 1190,
					plan4: 1570,
					plan5: 1950,
					plan6: 2330,
					plan7: 2710,
					plan8: 3090,
					plan9: -1,
					plan10: -1,
				},
			],
			dataQA: [
				{
					question: '多少人可以投保？',
					answer: '仅包含1-4类职业3人起保，包含5、6类职业需要5人起保',
				},
				{
					question: '对被保险人年龄限制是怎么样的？',
					answer: '被保险人年龄为18-65周岁',
				},
				{
					question: '保全加人如何收费的？',
					answer: '月计划加费规则是按照不足一月按一月收费，年计划按照剩余天数收费。',
				},
				{
					question: '投保人名称含有哪些关键字不能投保本保险？',
					answer:
						'如投保人名称中包含：<span class="u-font-weight-bold">危险品、人力资源、拆、分包、外包、劳务派遣、幕墙、脚手架、爆破、爆炸、渔业、隧道</span>，则不能投保本保险。',
				},
				{
					question: '对于被保险人的身份，必须是全职员工吗？比如以下几种情况的员工是否可以承保呢？',
					answer:
						'1、被保险人与投保人没有签署劳动合同或其他形式的雇佣合同，但却存在实际用工关系的员工；\n' +
						'2、企业雇佣的非全职临时工/小时工/兼职实习生等非全职雇员；\n' +
						'3、投保人（例如劳务派遣公司/人力资源公司）雇佣的人员签署了劳动合同或其他形式的雇佣合同但却外派到其他公司工作，并非为投保人工作的情形；\n' +
						'4、劳务公司派遣到投保人企业的员工，非与投保人直接签署劳动合同或其他形式的雇佣合同。\n' +
						'被保险人与投保人需存在“直接雇佣关系”，双方有签署劳动合同或其他书面形式的用工合同，且被保险人必须为投保人的“全职职员”，因此以上四种情形的被保险人不可以投保。',
				},
				{
					question: '投保本保险有哪些系统校验需要特别注意？',
					answer:
						'除了<span class="u-font-weight-bold">投保人信息真实性校验、最低投保人数校验、被保险人年龄校验、被保险人投保份数校验</span>等常规校验需要注意之外，以下几个特殊校验也需要重点关注。\n' +
						'①<span class="u-font-weight-bold">《投保重要事项确认书》盖章件模板</span>是否<span class="u-font-weight-bold">使用正确</span>、是否<span class="u-font-weight-bold">清晰完整</span>、是否<span class="u-font-weight-bold">正向上传、印章企业名称是否与投保人名称一致</span>；<span class="red-bold">切勿伪造印章投保！</span>\n' +
						'②<span class="u-font-weight-bold">经办人/联系人</span>是否存在于<span class="u-font-weight-bold">不同投保人的有效保单下</span>。\n' +
						'③<span class="u-font-weight-bold">投保人的所有有效保单</span>是否存在<span class="u-font-weight-bold">超过三个经办人/联系人</span>的情况。\n' +
						'如因系统校验核保未通过，请关注报错提示，进行相应调整后再次投保即可。',
				},
				{
					question: '新单和保全的付费方式可以不一致吗？',
					answer: '不可以，新单选择线下公对公转账支付保费，保全也需要通过公对公转账支付保费。',
				},
				{
					question: '公对公转账的时间对保险起期有影响吗？',
					answer:
						'公对公转账时间会决定保费到账时间，保费到账时间早于保险起期的，对保险起期无影响；如果保费到账时间晚于保险起期，保险起期将会被调整为保费到账日期的次日。',
				},
				{
					question: '发生退费时，纸质专票红冲是如何处理的？',
					answer:
						'开具纸质专票的保单，在发生保全减人或退保时，发票已抵扣的，须将《开具红字增值税专用发票信息表》电子版（加盖发票专用章）提交给工作人员；发票未抵扣的，须将发票原件寄回保险公司，并承担由此产生的快递费用。',
				},
				{
					question: '意外医疗的最长给付时间是多久？保单到期后还能保障多久？',
					answer:
						'按照条款约定，若被保险人因遭遇意外事故而于<span class="u-font-weight-bold">意外事故发生日</span><span class="red-bold">起一百八十天内</span>寻求合法注册的医生、护士、医院或救护车服务，则对其因此已支出的必需且合理的实际医药费用，保险公司按保险合同约定补偿该被保险人。\n' +
						'即使保险合同到期，只要是属于<span class="u-font-weight-bold">意外事故发生日</span><span class="red-bold">起一百八十天内</span>支出的必需且合理的实际医药费用，保险公司也会按保险合同约定补偿该被保险人。\n' +
						'注：意外事故骨折后续的拆取钢板费用不受180天的限制。',
				},
				{
					question: '本保险对替换率是怎样要求的？',
					answer: '本保险没有替换率的限制。同一职业类别才能替换，不同职业类别不能替换。',
				},
				{
					question: '拒保行业有哪些？',
					answer:
						'拒保行业包括渔业、森林砍伐业、矿业采石业、航运业以及涉及隧道作业、地下作业、山洞作业、水上作业、易燃易爆物品生产和运输、武器弹药研究和开发、驯兽及凶猛动物养殖的职业活动的企业。',
				},
				{
					question: '对特种作业证要求是怎样的？',
					answer:
						'未取得对应的特种作业证书进行特种作业操作引起的意外事故，保险公司不承担保险责任。特种作业的相关定义以国家《特种作业人员安全技术培训考核管理规定》为准。',
				},
				{
					question: '对高处作业的要求是怎样的？',
					answer:
						'本保险承保合同约定职业类别为5类和6类的被保险人在从事高处作业的职业活动期间所发生的保险事故。本保险所称的高处作业以《高处作业分级》（中华人民共和国国家标准GB/T 3608-2008）中规定的为准，<span class="u-font-weight-bold">如属于在距坠落高度基准面5米及以上有可能坠落的高处进行作业，前述被保险人应依法取得规定的特种作业证书。</span>\n' +
						'<span class="u-font-weight-bold">若被保险人在从事5米及以上高处作业时未系绑安全带，则保险公司不承担任何保险责任。</span>\n' +
						'<span class="u-font-weight-bold">对于职业类别为1至4类的被保险人，本保险不承保其任何5米及以上的高处作业。</span>',
				},
				{
					question: '本保险对于医院的要求是怎样的？',
					answer:
						'本保险所称的医院必须是经国家卫生部门评审确定的二级以上（含二级）公立医院。\n' +
						'本保险所称的医院不包括下列医院：北京市（平谷区、密云区、怀柔区）、天津市（滨海新区、静海区）、福建省南平市、安徽省宿州市、河北省（三河市、廊坊市、青龙县、兴隆县）的所有医院；福建省宁德市古田县医院；河北省承德市第六医院、邯郸市第一医院、馆陶县人民医院、元氏县中医院；河南省（开封市、信阳市、新密市、内黄县、通许县）所有医院，河南省新乡市中医院、新乡市第二人民医院、焦作市第五人民医院、许昌县人民医院、商水县人民医院、濮阳县第二人民医院、鹤壁煤业（集团）有限责任公司总医院；山东省（莱州市、栖霞市、威海市、金乡县、禹城）所有医院，山东滨州市中心医院、鱼台县人民医院、青岛市即墨区中医院、荣成市中医院、烟台市中医医院、聊城市中医医院；四川省宜宾市所有医院、雅安市雨城区人民医院、雅安市第二人民医院、富顺县中医医院、绵阳市人民医院、泸州市纳溪区人民医院、内江市第四人民医院、阿坝州林业中心医院、遂宁市大英县中医院；甘肃省民勤县人民医院、宁县人民医院；山西省运城市盐湖区人民医院；黑龙江鸡西市所有医院，黑龙江省中医医院、牡丹江市中医院、牡丹江市第二人民医院、哈尔滨市第一医院、五大连池市第一人民医院；吉林省四平市所有医院，吉林省中医医院、通化市人民医院、长春市中心医院；辽宁省铁岭市所有医院，辽宁省中医医院；海南省第三人民医院。',
				},
			],
			isDownLoading: false,
			option: {
				card: true,
				stripe: true,
				border: true,
				align: 'center',
				menuAlign: 'center',
				gutter: 20,
				index: true,
				indexLabel: '序号',
				header: false,
				editBtn: false,
				delBtn: false,
				column: [
					{
						label: '标题',
						prop: 'title',
					},
				],
			},
			listDatas: [
				{
					title: '和顺保互联网团意B款_常见问题_仅投保基本方案',
					fileUrl: '/download/my-b/my_1.docx',
					fileName: '和顺保互联网团意B款_常见问题_仅投保基本方案.docx',
				},
				{
					title: '和顺保互联网团意B款_各条款保险责任描述_仅投保基本方案',
					fileUrl: '/download/my-b/my_2.docx',
					fileName: '和顺保互联网团意B款_各条款保险责任描述_仅投保基本方案.docx',
				},
				{
					title: '和顺保互联网团意B款_发票及理赔须知',
					fileUrl: '/download/my-b/my_3.docx',
					fileName: '和顺保互联网团意B款_发票及理赔须知.docx',
				},
				{
					title: '和顺保互联网团意_健康意外险索赔证明资料清单',
					fileUrl: '/download/my-b/my_4.pdf',
					fileName: '和顺保互联网团意_健康意外险索赔证明资料清单.pdf',
				},
				{
					title: '和顺保互联网团意个人保险索赔申请表',
					fileUrl: '/download/my-b/my_5.pdf',
					fileName: '和顺保互联网团意个人保险索赔申请表.pdf',
				},
				{
					title: '和顺保互联网团意_海报(无二维码)',
					fileUrl: '/download/my-b/my_6.jpg',
					fileName: '和顺保互联网团意_海报(无二维码).jpg',
				},
				{
					title: '美亚附加意外每日住院津贴团体收入保障保险（2021年第一版）',
					fileUrl: '/download/my-b/my1.pdf',
					fileName: '美亚附加意外每日住院津贴团体收入保障保险.pdf',
				},
				{
					title: '美亚附加意外医药补偿团体医疗保险（2021年第五版）（互联网专属）',
					fileUrl: '/download/my-b/my2.pdf',
					fileName: '美亚附加意外医药补偿团体医疗保险.pdf',
				},
				{
					title: '美亚团体意外伤害保险（2021年第一版）（互联网专属）',
					fileUrl: '/download/my-b/my3.pdf',
					fileName: '美亚团体意外伤害保险.pdf',
				},
				{
					title: '美亚附加每一意外事故总赔偿限额条款（2021年第一版）（互联网专属）',
					fileUrl: '/download/my-b/my4.pdf',
					fileName: '美亚附加每一意外事故总赔偿限额条款.pdf',
				},
				{
					title: '美亚附加不承保特定医院条款（2021年第二版）',
					fileUrl: '/download/my-b/my5.pdf',
					fileName: '美亚附加不承保特定医院条款.pdf',
				},
				{
					title: '美亚附加经济制裁责任免除条款',
					fileUrl: '/download/my-b/my6.pdf',
					fileName: '美亚附加经济制裁责任免除条款.pdf',
				},
				{
					title: '美亚附加特种作业限制条款（2021年第二版）（互联网专属）',
					fileUrl: '/download/my-b/my7.pdf',
					fileName: '美亚附加特种作业限制条款.pdf',
				},
				{
					title: '美亚附加仅承保境内意外事故条款（2021年第二版）（互联网专属）',
					fileUrl: '/download/my-b/my8.pdf',
					fileName: '美亚附加仅承保境内意外事故条款.pdf',
				},
				{
					title: '美亚附加特定职业类别人员高处作业条款（2021年第二版）（互联网专属）',
					fileUrl: '/download/my-b/my9.pdf',
					fileName: '美亚附加特定职业类别人员高处作业条款.pdf',
				},
				{
					title: '和顺保互联网团意B款_投保人声明及确认',
					fileUrl: '/download/my-b/my10.pdf',
					fileName: '和顺保互联网团意B款_投保人声明及确认.doc',
				},
				{
					title: '和顺保互联网团意B款_责任免除_仅投保基本方案',
					fileUrl: '/download/my-b/my11.pdf',
					fileName: '和顺保互联网团意B款_责任免除_仅投保基本方案.docx',
				},
			],
		}
	},
	created() {},
	mounted() {
		this.setPrice(12)
	},
	methods: {
		//设置金额
		setPrice(month = 0) {
			if (month === 0) {
				this.$message.error('选择月份有误!')
				return
			}
			let tempPercent = 0
			switch (month) {
				case 1:
					tempPercent = 0.2
					break
				case 2:
					tempPercent = 0.3
					break
				case 3:
					tempPercent = 0.4
					break
				case 4:
					tempPercent = 0.5
					break
				case 5:
					tempPercent = 0.6
					break
				case 6:
					tempPercent = 0.7
					break
				case 7:
					tempPercent = 0.75
					break
				case 8:
					tempPercent = 0.8
					break
				case 9:
					tempPercent = 0.85
					break
				case 10:
					tempPercent = 0.9
					break
				case 11:
					tempPercent = 0.95
					break
				case 12:
					tempPercent = 1
					break
			}
			let tempWei = `元/${month}月`
			let tempYearData = this.deepClone(this.priceYear)
			tempYearData.forEach((itemData) => {
				for (let i = 1; i <= 10; i++) {
					let tempVal = itemData[`plan${i}`]
					if (tempVal < 0) {
						itemData[`plan${i}`] = '不适用'
					} else {
						itemData[`plan${i}`] = tempPercent === 1 ? tempVal + tempWei : (tempVal * tempPercent).toFixed(2) + tempWei
					}
				}
			})
			if (this.dataPlan.length > 7) {
				//添加过则
				this.dataPlan.splice(7, 6, ...tempYearData)
			} else {
				this.dataPlan.push(...tempYearData)
			}
		},
		spanMethodPlan({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 6) {
				if (columnIndex === 0) {
					return [1, 12]
				}
			}
			// if (columnIndex === 0) {
			//     if (rowIndex >= 9) {
			//         if (columnIndex === 0) {
			//             if (rowIndex % 2 === 1) {
			//                 return {
			//                     rowspan: 2,
			//                     colspan: 1
			//                 }
			//             } else {
			//                 return {
			//                     rowspan: 0,
			//                     colspan: 0
			//                 }
			//             }
			//         }
			//     }
			// }
			// if (rowIndex < 9) {
			//     if (columnIndex === 0) {
			//         return [1, 2]
			//     } else if (columnIndex === 1) {
			//         return [0, 0]
			//     }
			// }
		},
		handleInsure() {
			this.$emit('insure')
		},
		handleDownLoad() {
			this.isDownLoading = true
			let fileName = `my_${this.productId}_template_chinalife_${currentYYYYmmdd()}.xlsx`
			handleDownCategoryFile(
				`/dist/distInsure/categoryDownloadDetail
/${this.productId}`,
				{},
				fileName,
			)
				.then(() => {
					//下载成功
				})
				.finally(() => {
					this.isDownLoading = false
				})
		},
		computePrice(val) {
			this.setPrice(val)
		},
		onDownload({fileUrl, fileName}) {
			handleDownCustom(fileUrl, {}, fileName, 'get')
		},
	},
}
</script>

<style scoped>
.el-col {
	font-size: 14px;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

.item {
	margin-bottom: 18px;
}

.ul,
li {
	list-style: none;
}

span.link {
	display: block;
	text-indent: 1em;
}

h2 {
	margin: 0px;
	padding: 0px;
}
</style>
